module.exports = __webpack_public_path__ + "static/media/gq.847b66f6.png";